import React from "react";
export const display_advice = (response) => {
    let advice=null;
    let error_control=false;
    let success_control = false;

    //const success_control = Object.keys(expectedMessage).every((key) => response[key] === expectedMessage[key]);



    if (response.response[0] !== undefined && response.response[0][0] !== undefined) {
      if (response.response[0][0].success !== undefined && response.response[0][0].success === false) {
        advice = response.response[0][0].advice + "!";
        error_control = true;
      }
    }
    else{
      success_control = true;
    }
      
    
      return [success_control,advice,error_control];
        
    };

 
 